import axios from 'axios';
// import { encryptStorage } from '@/utils/storage';
import { serverUrl } from '../config.js';

// const token = encryptStorage.getItem('token');

export const apiClient = axios.create({
  baseURL: `${serverUrl}/whatsapp/`, // http://localhost:3000
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    // Authorization: `Token ${encryptStorage.getItem('token')}`,
  },
});

export const apiOfficialClient = axios.create({
  baseURL: `${serverUrl}/whatsapp-official/`,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    // Authorization: `Token ${encryptStorage.getItem('token')}`,
  },
});


